<div class="sched-disc-config-schedule">

	<schedule [target]="schedule"></schedule>

</div>
